import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { State } from '../state/state';
import * as fromCard from '../state/selectors';

@Injectable()
export class CardOptionQuery {

  constructor(private store: Store<State>) { }

  get values(): Observable<string> {
    return this.store.pipe(
      select(fromCard.getSearchOption)
    )
  }

}